export default __webpack_public_path__ + "static/media/social-tip.890307e4.svg";